import Id from './Id';
import Created from './Created';
import Updated from './Updated';
import Name from './Name';


export const labels = {
  Id: 'Id',
  Name: 'Név',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Created',
}, {
  value: 'Name',
}, {
  value: 'Status',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
}, {
  value: 'Created',
}, {
  value: 'Updated',
}];

export const defaultSort = {
  prop: Name.propName,
  order: 'ascending'
};

export default {
  Id,
  Name,
  Created,
  Updated,
};
